<template>
    <div class="delete-files dialog-wraper">
        <p><span v-t="'Deletefiletip'" class="record-tip mr-8"></span><b v-if="text.strong">{{text.result}}</b><span v-if="!text.strong">{{text.result}}</span></p>
        <div class="dialog-foot">
            <el-button size="mini" @click="close" v-cloak>{{$t('Cancel')}}</el-button><el-button :loading="doing" @click="deleteFiles" type="danger" size="mini" v-cloak>{{$t('Confirm')}}</el-button>
        </div>
    </div>
</template>

<script>
import { mapState,mapMutations, mapActions} from 'vuex';
export default {
    data(){
        return {
            checked: false
        }
    },
    created(){
        this.$store.commit('index/LOADING',false)
        this.$store.commit('latest/LOADING',false)
        this.$store.commit('received/LOADING',false)
    },
    computed:{
        ...mapState('index',[
            'fileids',
            'fileList',
            'doing'
        ]),
        ...mapState([
            'smodule',
            'group',
            'dialogData'
        ]),
        currentFile(){
            let len = this.fileids.length
            return len === 1 ? this.fileList.filter(item => item.id == this.fileids[0]) : []
        },
        text(){
            let currentFile = this.currentFile[0]
            let fname = this.dialogData.fname
            return fname ? {strong: true,result:`「${fname}」`} : currentFile ? {strong: true, result:`「${currentFile.fname}」`} : {strong: false, result: this.$t('Selectedfiles')}
        },
        doing(){
            let state = this.$store.state
            return state.index.loading || state.latest.loading || state.received.loading
        }
    },
    methods:{
        ...mapActions([
            'close'
        ]),
        docheck(){
            this.checked = !this.checked
        },
        deleteFiles(){
            let {sid,fileid,groupid} = this.dialogData
            this.$store.dispatch(`${this.smodule}/deleteFiles`,{fileid,groupid,sid})
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/dialog/file/DeleteFiles.vue